import cs from 'classnames';

import { FormattedOption } from 'types/dictionaries';

import { ReactComponent as MinusCircleIcon } from 'assets/icons/minus-circle.svg';
import { ReactComponent as TickCircleIcon } from 'assets/icons/tick-circle.svg';

import styles from './SkillsetItem.module.scss';

interface SkillsetItemProps {
  skillset: string;
  skillsetsMatches: string[];
  skillsetsDictionary: FormattedOption[];
}

const SkillsetItem = ({
  skillset,
  skillsetsMatches,
  skillsetsDictionary
}: SkillsetItemProps) => {
  const isSkillsetMatch = skillsetsMatches.includes(skillset);
  const label = skillsetsDictionary.find(
    (dictionaryItem) => dictionaryItem.value === skillset
  )?.label;

  return (
    <div className={styles.wrapper}>
      <div
        className={cs(styles.iconWrapper, { [styles.match]: isSkillsetMatch })}
      >
        {isSkillsetMatch ? (
          <TickCircleIcon width={18} height={18} />
        ) : (
          <MinusCircleIcon width={18} height={18} />
        )}
      </div>
      <span className={cs(styles.text, { [styles.match]: isSkillsetMatch })}>
        {label}
      </span>
    </div>
  );
};

export default SkillsetItem;
